import { useDispatch } from 'react-redux';
import { ApiError } from 'services/api';
import { useUpdateEspAccount } from 'api/ESPAccountsAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { useModalsContext, useSendingPlatformsQueryContext } from '../contexts';

export const useUpdateAccount = () => {
  const dispatch = useDispatch();
  const { hideModal } = useModalsContext();
  const { refetchEspAccounts } = useSendingPlatformsQueryContext();

  const { mutate: updateAccount, isLoading } = useUpdateEspAccount({
    onSuccess: () => {
      refetchEspAccounts();
      dispatch(addPositiveToast('Successfully updated account.'));
      hideModal();
    },
    onError: (e: unknown) => {
      const errorText = (e as ApiError)?.response?.data;
      dispatch(addNegativeToast(errorText));
      hideModal();
    },
  });

  return { isLoading, updateAccount };
};
